export default "<div class=\"validator-error-message\" *ngIf=\"errorMessage\">\r\n    {{errorMessage}}\r\n</div>\r\n";